
























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import Loader from "@/components/Loader.vue";
import LiveContent from "@/components/contentset/manager/LiveContent.vue";
import ConfigureContent from "@/components/contentset/manager/ConfigureContent.vue";
import PreviousContent from "@/components/contentset/manager/PreviousContent.vue";


@Component({
  components: {
    Loader,
    LiveContent,
    ConfigureContent,
    PreviousContent
  }
})
export default class ContentSetManager extends Vue {
  @Prop() public contentSet: IContentSet;
  @Prop() public loading: boolean;
}
